import BasePage from '../../../../../components/table_page';
import Form from './form';

export default {
  name: 'collect_field',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('tpm_budget_act_collect_field');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          code: val.code,
          row,
        };

        this.modalConfig.title = val.name || '查看';

        this.openModal();
      }
    },
  },
};
